<template>
  <div class="page">
    <div class="content">
      <!-- 좌측: KPI 그리드 -->
      <div class="left">
        <!-- 상단 타이틀 -->
        <div class="title-bar">101 / 비행기 매출 분석</div>
        <ag-grid-vue
          class="ag-ap-balham grid"
          :columnDefs="columnDefs"
          :rowData="rowData"
          :gridOptions="gridOptions"
          :theme="theme"
        />

        <div class="panel">
          <table class="info-table">
            <thead>
              <tr style="background-color: yellow; color: crimson;">
                <th style="width: 20%;">목표 달성률</th>
                <th style="width: 20%;">전월 대비 매출</th>
                <th style="width: 20%;">전월 대비 탑승객</th>
                <th style="width: 20%;">당월 최고 매출</th>
                <th style="width: 20%;">당월 최고 탑승객</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td class="big">{{ achievement }}%</td>
                <td class="big">78,769 (<span style="color: red;">+12.3% ↑</span>)</td>
                <td class="big">4,358 (<span style="color: blue;">-3.1% ↓</span>)</td>
                <td class="big">2,089</td>
                <td class="big">273</td>
              </tr>
            </tbody>
          </table>
        </div>
        <!-- 요일 -->
        <div class="panel">
          <div style="font-weight: bold;">일별 탑승객 현황</div>
          <table class="calendar-table">
            <thead>
              <tr>
                <th>주간</th>
                <th>일</th>
                <th>월</th>
                <th>화</th>
                <th>수</th>
                <th>목</th>
                <th>금</th>
                <th>토</th>
              </tr>
            </thead>
            <!-- 로딩 중 -->
            <tbody v-if="mainTableLoading">
              <tr>
                <td :colspan="8">데이터 로딩 중...</td>
              </tr>
            </tbody>
            <!-- 데이터 있음 -->
            <tbody
              v-else-if="
                weeklySalesData.qtyWeeks && weeklySalesData.qtyWeeks.length > 0
              "
            >
              <template
                v-for="(qtyWeek, index) in weeklySalesData.qtyWeeks"
                :key="'week-group-' + index"
              >
                <!-- 수량 행 -->
                <tr>
                  <td>{{ qtyWeek.week }}주</td>
                  <td>{{ qtyWeek.sun }}</td>
                  <td>{{ qtyWeek.mon }}</td>
                  <td>{{ qtyWeek.tue }}</td>
                  <td>{{ qtyWeek.wed }}</td>
                  <td>{{ qtyWeek.thu }}</td>
                  <td>{{ qtyWeek.fri }}</td>
                  <td>{{ qtyWeek.sat }}</td>
                </tr>
              </template>
            </tbody>
            <!-- 데이터 없음 -->
            <tbody v-else>
              <tr>
                <td :colspan="8">데이터가 없습니다.</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <!-- 우측 패널 -->
      <div class="right">
        <!-- 항공편 정보 -->
        <!-- <div class="panel highlight">
          <div>총 고객수 : <b>59,432</b></div>
          <div>가용 좌석 : <b>37,443</b></div>
        </div> -->
        <div class="title-bar">비행 정보</div>
        <ag-grid-vue
          class="ag-ap-balham aircraft-grid"
          :columnDefs="aircraftColumnDefs"
          :rowData="aircraftRowData"
          :gridOptions="aircraftGridOptions"
          :theme="theme"
        />

        <div class="title-bar">매출 TOP 3</div>
        <ag-grid-vue
          class="ag-ap-balham top3-grid"
          :columnDefs="top3ColumnDefs"
          :rowData="top3RowData"
          :gridOptions="top3GridOptions"
          :theme="theme"
        />

        <div class="title-bar">탑승률 TOP 3</div>
        <ag-grid-vue
          class="ag-ap-balham top3-grid"
          :columnDefs="top3BordColumnDefs"
          :rowData="top3BordRowData"
          :gridOptions="top3BordGridOptions"
          :theme="theme"
        />


        <!-- KPI -->

        <!-- 메모 -->
        <!-- <div class="panel">
          <h3>메모</h3>
          <textarea class="memo"></textarea>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import { AgGridVue } from "ag-grid-vue3";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-balham.css";
import { themeBalham } from "ag-grid-community";

export default {
  components: { AgGridVue },

  data() {
    return {
      achievement: 83.1,

      mainTableLoading: false,

      theme: themeBalham.withParams({
        fontFamily: "Malgun Gothic",
        borderColor: "#c0c0c0",
        wrapperBorder: true,
        headerRowBorder: true,
        headerColumnBorderHeight: "100%",
        rowBorder: { style: "solid", width: 1 },
        columnBorder: { style: "solid", width: 1 },
      }),

      columnDefs: [
        {
          headerName: "",
          field: "no",
          width: 35,
          pinned: "left",
          cellStyle: { textAlign: "center", backgroundColor: "#c8fdd1" },
          valueGetter: "node.rowIndex + 1",
        },
        {
          headerName: "구분",
          field: "name",
          width: 110,
          pinned: "left",
          cellStyle: { textAlign: "center", backgroundColor: "#c8fdd1" },
        },
        ...this.createMonthCols(),
        {
          headerName: "합계",
          field: "total",
          width: 110,
          valueFormatter: (p) => this.format(p.value),
          // cellStyle: { background: "#ffe699", fontWeight: "bold" },
          cellStyle: (params) => this.cellStyle(params),
        },
      ],

      gridOptions: {
        headerHeight: 35,
        rowHeight: 26,
        defaultColDef: {
          resizable: true,
          cellStyle: { textAlign: "right" },
        },
      },

      rowData: this.createRowData(),

      aircraftColumnDefs: [
        // { headerName: "편명", field: "regNo", flex: 1, cellStyle: { textAlign: "center", backgroundColor: "#f9f9f9" } },
        // { headerName: "출발지", field: "origin", flex: 1, cellStyle: { textAlign: "center" } },
        // { headerName: "도착지", field: "destination", flex: 1, cellStyle: { textAlign: "center" } },
        // { headerName: "출발시간", field: "departTime", flex: 1, cellStyle: { textAlign: "center" } },
        // { headerName: "도착시간", field: "arrivalTime", flex: 1, cellStyle: { textAlign: "center" } },
        // { headerName: "제작번호", field: "serial", flex: 1, cellStyle: { textAlign: "center" } },
        // { headerName: "제작일자", field: "delivery", flex: 1, cellStyle: { textAlign: "center" } },
        // { headerName: "등록일자", field: "eis", flex: 1, cellStyle: { textAlign: "center" } },
        // { headerName: "좌석", field: "config", flex: 1, cellStyle: { textAlign: "center" } },
        {
          headerName: "노선그룹",
          field: "regGroup",
          flex: 1.2,
          cellStyle: { 
            textAlign: "center", 
            backgroundColor: "#f0f0f0", 
            alignContent: "center",
            borderBottom: "1px solid #c0c0c0" // 병합된 셀 하단에 선 추가
          },
          rowSpan: this.calculateRowSpan,
          valueFormatter: (params) => {
            // 이전 행과 값이 같으면 빈 문자열을 반환하여 텍스트 중복 출력 방지
            const rowIndex = params.node.rowIndex;
            if (rowIndex > 0) {
              const prevNode = params.api.getDisplayedRowAtIndex(rowIndex - 1);
              if (prevNode && prevNode.data && prevNode.data.regGroup === params.value) {
                return "";
              }
            }
            return params.value;
          },
          cellRenderer: params => {
            return params.value ? params.value.replace(/\n/g, "<br/>") : "";
          },
        },
        {
          headerName: "편명",
          field: "regNo",
          flex: 1,
          cellStyle: { textAlign: "center" },
        },
        {
          headerName: "출발지",
          field: "origin",
          flex: 1,
          cellStyle: { textAlign: "center" },
        },
        {
          headerName: "도착지",
          field: "destination",
          flex: 1,
          cellStyle: { textAlign: "center" },
        },
        {
          headerName: "객단가",
          field: "custTran",
          flex: 1,
          cellStyle: { textAlign: "center" },
        },
        {
          headerName: "좌석\n점유율",
          field: "custRate",
          flex: 1,
          cellStyle: { textAlign: "center" },
        },
      ],

      aircraftRowData: [
        // { regNo: "101", origin: "ICN", destination: "LAX", departTime: "13:02", arrivalTime:"07:28", serial: "66407", delivery: "20.07.31", eis: "21.03.31", config: "W56Y253" },
        // { regNo: "103", origin: "ICN", destination: "IAD", departTime: "13:20", arrivalTime:"17:55(+1일)", serial: "66409", delivery: "20.09.25", eis: "22.10.06", config: "W56Y253" },
        // { regNo: "111", origin: "EWR", destination: "ICN", departTime: "01:00", arrivalTime:"05:15(+1일)", serial: "66816", delivery: "21.03.03", eis: "23.05.26", config: "W56Y253" },
        // { regNo: "131", origin: "HKG", destination: "ICN", departTime: "13:30", arrivalTime:"18:15", serial: "63314", delivery: "18.02.07", eis: "22.09.23", config: "W56Y264" },
        // { regNo: "135", origin: "NRT", destination: "ICN", departTime: "12:30", arrivalTime:"15:10", serial: "63315", delivery: "18.02.03", eis: "23.03.30", config: "W56Y264" },
        // { regNo: "601", origin: "LAX", destination: "ICN", departTime: "10:50", arrivalTime:"15:50(+1일)", serial: "37307", delivery: "16.02.04", eis: "24.12.18", config: "W35Y291" },
        // { regNo: "731", origin: "DAD", destination: "ICN", departTime: "09:30", arrivalTime:"14:30", serial: "37308", delivery: "16.03.15", eis: "25.03.25", config: "W35Y309" },
        // { regNo: "735", origin: "ICN", destination: "HKG", departTime: "09:15", arrivalTime:"12:00", serial: "62082", delivery: "16.06.24", eis: "25.06.25", config: "W35Y309" },
        // { regNo: "801", origin: "HNL", destination: "ICN", departTime: "14:30", arrivalTime:"19:05", serial: "37931", delivery: "16.09.30", eis: "25.12.19", config: "W35Y291" },
        { regGroup:"LA",             regNo: "101", origin: "ICN", destination: "LAX", custTran: "5310", custRate: "70%" },
        { regGroup:"LA",             regNo: "102", origin: "LAX", destination: "ICN", custTran: "5706", custRate: "81%" },
        { regGroup:"뉴욕",           regNo: "111", origin: "EWR", destination: "ICN", custTran: "4418", custRate: "88%" },
        { regGroup:"뉴욕",           regNo: "112", origin: "ICN", destination: "EWR", custTran: "4500", custRate: "80%" },
        { regGroup:"샌프란\n시스코", regNo: "121", origin: "ICN", destination: "SFO", custTran: "5100", custRate: "75%" },
        { regGroup:"샌프란\n시스코", regNo: "122", origin: "SFO", destination: "ICN", custTran: "5250", custRate: "78%" },
        { regGroup:"워싱턴\nDC",     regNo: "103", origin: "ICN", destination: "IAD", custTran: "5630", custRate: "85%" },
        { regGroup:"워싱턴\nDC",     regNo: "104", origin: "IAD", destination: "ICN", custTran: "5600", custRate: "83%" },
        { regGroup:"호놀룰루",       regNo: "801", origin: "HNL", destination: "ICN", custTran: "5375", custRate: "82%" },
        { regGroup:"호놀룰루",       regNo: "802", origin: "ICN", destination: "HNL", custTran: "5200", custRate: "78%" },
        { regGroup:"나리타",         regNo: "135", origin: "NRT", destination: "ICN", custTran: "6082", custRate: "77%" },
        { regGroup:"나리타",         regNo: "136", origin: "ICN", destination: "NRT", custTran: "5800", custRate: "82%" },
        { regGroup:"방콕",           regNo: "601", origin: "ICN", destination: "BKK", custTran: "5400", custRate: "88%" },
        { regGroup:"방콕",           regNo: "602", origin: "BKK", destination: "ICN", custTran: "5550", custRate: "91%" },
        { regGroup:"다낭",           regNo: "731", origin: "DAD", destination: "ICN", custTran: "5832", custRate: "83%" },
        { regGroup:"다낭",           regNo: "732", origin: "ICN", destination: "DAD", custTran: "5500", custRate: "85%" },
        { regGroup:"홍콩",           regNo: "735", origin: "ICN", destination: "HKG", custTran: "5429", custRate: "85%" },
        { regGroup:"홍콩",           regNo: "736", origin: "HKG", destination: "ICN", custTran: "5935", custRate: "90%" },
      ],

      aircraftGridOptions: {
        headerHeight: 30,
        rowHeight: 26,
        defaultColDef: { resizable: true },
        suppressDragLeaveHidesColumns: true,
        suppressRowTransform: true,
      },

      top3ColumnDefs: [
        {
          headerName: "",
          field: "no",
          width: 35,
          pinned: "left",
          cellStyle: { textAlign: "center", backgroundColor: "#f0f0f0" },
          valueGetter: "node.rowIndex + 1",
        },
        {
          headerName: "노선",
          field: "origin",
          flex: 1.2,
          cellStyle: { textAlign: "center" },
        },
        {
          headerName: "매출액",
          field: "destination",
          flex: 0.9,
          cellStyle: { textAlign: "center" },
        },
        {
          headerName: "수익성",
          field: "custTran",
          flex: 0.9,
          cellStyle: { textAlign: "center" },
        },
        {
          headerName: "수익기여도",
          field: "custRate",
          flex: 1.2,
          cellStyle: { textAlign: "center" },
        },
      ],

      top3RowData: [
        {  origin: "인천 - 뉴욕",   destination: "12310", custTran: "15310", custRate: "13%"  },
        {  origin: "인천 - 나리타", destination: "11630", custTran: "13630", custRate: "10%"  },
        {  origin: "인천 - 다낭",   destination: "9418", custTran: "12418" , custRate: "8%"  },
      ],

      top3GridOptions: {
        headerHeight: 30,
        rowHeight: 26,
        defaultColDef: { resizable: true },
      },

      top3BordColumnDefs: [
        {
          headerName: "",
          field: "no",
          width: 35,
          pinned: "left",
          cellStyle: { textAlign: "center", backgroundColor: "#f0f0f0" },
          valueGetter: "node.rowIndex + 1",
        },
        {
          headerName: "노선",
          field: "origin",
          flex: 1.2,
          cellStyle: { textAlign: "center" },
        },
        {
          headerName: "탑승률",
          field: "destination",
          flex: 0.9,
          cellStyle: { textAlign: "center" },
        },
        {
          headerName: "수익성",
          field: "custTran",
          flex: 0.9,
          cellStyle: { textAlign: "center" },
        },
        {
          headerName: "수익기여도",
          field: "custRate",
          flex: 1.2,
          cellStyle: { textAlign: "center" },
        },
      ],

      top3BordRowData: [
        {  origin: "인천 - 다낭",   destination: "90%", custTran: "12418", custRate: "12%" },
        {  origin: "인천 - 홍콩",   destination: "87%", custTran: "11935", custRate: "9%" },
        {  origin: "인천 - 화와이", destination: "85%", custTran: "10082", custRate: "8%" },
      ],

      top3BordGridOptions: {
        headerHeight: 30,
        rowHeight: 26,
        defaultColDef: { resizable: true },
      },

      top3RevenueColumnDefs: [
        {
          headerName: "",
          field: "no",
          width: 35,
          pinned: "left",
          cellStyle: { textAlign: "center", backgroundColor: "#f0f0f0" },
          valueGetter: "node.rowIndex + 1",
        },
        {
          headerName: "노선",
          field: "origin",
          flex: 1,
          cellStyle: { textAlign: "center" },
        },
        {
          headerName: "탑승률",
          field: "destination",
          flex: 1,
          cellStyle: { textAlign: "center" },
        },
        {
          headerName: "수익성",
          field: "custTran",
          flex: 1,
          cellStyle: { textAlign: "center" },
        },
      ],

      top3RevenueRowData: [
        {  origin: "인천 - 뉴욕",   destination: "95%", custTran: "15310" },
        {  origin: "인천 - 나리타", destination: "92%", custTran: "13630" },
        {  origin: "인천 - 다낭",   destination: "90%", custTran: "12418" },
        {  origin: "인천 - 홍콩",   destination: "87%", custTran: "11935" },
        {  origin: "인천 - 화와이", destination: "85%", custTran: "10082" },
      ],

      top3RevenueGridOptions: {
        headerHeight: 30,
        rowHeight: 26,
        defaultColDef: { resizable: true },
      },
      
    };
  },

  computed: {
    weeklySalesData() {
      // 빈 6주치 데이터를 기본적으로 생성하도록 설정 (추후 API 연동 시 data에서 처리 가능)
      const qtyWeeks = Array.from({ length: 5 }, (_, i) => ({
        week: i + 1,
        sun:  Math.floor(Math.random() * 401),
        mon:  Math.floor(Math.random() * 401),
        tue:  Math.floor(Math.random() * 401),
        wed:  Math.floor(Math.random() * 401),
        thu:  Math.floor(Math.random() * 401),
        fri:  Math.floor(Math.random() * 401),
        sat:  Math.floor(Math.random() * 401),
      }));
      return { qtyWeeks };
    },
  },

  methods: {
    createMonthCols() {
      return Array.from({ length: 12 }, (_, i) => ({
        headerName: `${i + 1}월`,
        field: `m${i + 1}`,
        flex: 1,
        valueFormatter: (p) => this.format(p.value),
        cellStyle: (params) => this.cellStyle(params),
      }));
    },

    createRowData() {
      return [
        // this.row("기장명", ["남궁명", "남궁명", "남궁명"], true),
        // this.row("총 승무원", [13, 13, 13], true),
        // this.row("총 탑승객수", [4454, 4233, 4358], true),
        // this.row("매출원가", [67148, 51048, 35801], true),
        // this.row("목표매출", [81771, 49169, 65207], true),
        // this.row("예상매출", [13139, 96121, 78769], true),
        this.row("기장명", [], true),
        this.row("총 승무원", [], true),
        this.row("총 탑승객수", [], true),
        this.row("매출원가", [], true),
        this.row("목표매출", [], true),
        this.row("예상매출", [], true),
        this.row("실매출", [], true),
        this.row("차이", [], true),
        this.row("여객매출", [], true),
        this.row("화물매출", [], true),
        this.row("부가매출", [], true),
        this.row("단가", [], true),
        this.row("손익", [], true),
        this.row("운항횟수", [], true),
        this.row("좌석당매출", [], true),
        this.row("가용좌석", [], true),
        this.row("탑승률", [], true),
        // this.row("실매출", [80,70,80,100,105,110,125,120,110,100,100,100], true),
        // this.row("월별약정", [17456,15274,17456,21820,22911,24002,27275,26184,24552,22320,22320,22320]),
        // this.row("차액", [-4364,-6546,-4364,0,1091,2182,5455,4364,2232,0,0,0], false, true),
        // this.row("총매출", [30595,29971,30207,22825]),
        // this.row("수수료", [7821,8062,7468]),
        // this.row("보증금액", [20284,20757,20489]),
        // this.row("실제보증", [13261,13561,13861,14737]),
        // this.row("수수료율", [25.6,26.9,24.7], true),
      ];
    },

    row(name, arr, isPercent = false, isDiff = false) {
      const obj = { name };
      let sum = 0;

      for (let i = 1; i <= 12; i++) {
        const val = arr[i - 1] ?? "";
        obj[`m${i}`] = val;
        if (!isPercent && val !== "") sum += val;
      }

      obj.total = isPercent ? "" : sum;
      obj._type = isPercent ? "percent" : isDiff ? "diff" : "normal";
      return obj;
    },

    format(val) {
      if (val === "" || val == null) return "";
      return typeof val === "number" ? val.toLocaleString() : val;
    },

    cellStyle(params) {
      const type = params.data._type;
      const val = params.value;

      let style = { textAlign: "right" };

      if (type === "diff") {
           style.color = val > 0 ? "red" : val < 0 ? "blue" : "black";
      }

      if (params.node.rowIndex % 2 !== 1) {
        style.backgroundColor = "#c8fdd1";
      }

      return style;
    },

    calculateRowSpan(params) {
      if (!params.data || !params.data.regGroup) return 1;
      const sBRANCH_NM = params.data.regGroup;
      const rowIndex = params.node.rowIndex;

      // 이전 행과 값이 같으면 1 반환 (병합된 셀의 일부로 처리됨)
      if (rowIndex > 0) {
        const prevNode = params.api.getDisplayedRowAtIndex(rowIndex - 1);
        if (prevNode && prevNode.data && prevNode.data.regGroup === sBRANCH_NM) {
          return 1;
        }
      }

      // 이후 행들과 값이 같은지 확인하여 병합할 행 수 계산
      let count = 1;
      let nextIndex = rowIndex + 1;
      let nextNode = params.api.getDisplayedRowAtIndex(nextIndex);

     while (nextNode && nextNode.data && nextNode.data.regGroup === sBRANCH_NM) {
      count++;
      nextIndex++;
      nextNode = params.api.getDisplayedRowAtIndex(nextIndex);
      }
      return count;

    },
  },
};
</script>

<style scoped>
.page {
  padding: 10px;
}

.title-bar {
  font-weight: bold;
  margin-bottom: 10px;
}

.content {
  display: flex;
}

.left {
  flex: 3;
}

.aircraft-grid {
  /* 우측 비행 정보 그리드: 데이터 양에 맞춰 높이 유지 */
  height: 445px;
  margin-bottom: 10px;
}

.top3-grid {
  /* 우측 비행 정보 그리드: 데이터 양에 맞춰 높이 유지 */
  height: 120px;
  margin-bottom: 10px;
}
.grid {
  /* 좌측 메인 그리드: 14행 데이터가 스크롤 없이 표시되는 최적 높이 */
  height: 500px;
  margin-bottom: 15px;
}
:deep(.grid .ag-cell) {
  font-size: 1rem;
  text-align: right;
  /* padding-right: 3px; */
}
:deep(.grid .ag-header-cell-label),
:deep(.aircraft-grid .ag-header-cell-label),
:deep(.top3-grid .ag-header-cell-label) {
  justify-content: center !important;
  white-space: pre-line;
  text-align: center;
}
:deep(.ag-header-cell-text) {
  font-weight: bold !important;
  color: #333;
  font-size: 0.78rem;
}

.right {
  flex: 1;
  margin-left: 10px;
}

.panel {
  background: #fff;
  border: 1px solid #ccc;
  padding: 5px;
  margin-bottom: 2px;
}

.highlight {
  background: #fff3cd;
}

.big {
  font-size: 20px;
  text-align: center;
  font-weight: bold;
}

.memo {
  width: 100%;
  height: 80px;
}

.info-table{
  width: 100%;
  border-collapse: collapse;
}

.info-table th,
.info-table td {
  border: 1px solid black;
  text-align: center;
  padding: 3px;
}

.calendar-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.7rem;
  margin-top: 2px;
}

.calendar-table th,
.calendar-table td {
  border: 1px solid black;
  text-align: center;
  padding: 3px;
}

.calendar-table th {
  background-color: #a0caf3;
  font-weight: bold;
}

.calendar-table td {
  background-color: #ffffff;
  font-weight: bold;
}
</style>
